import {number, string} from '../../../helpers/validations';

export const validationMap = {
    number: number,
    bank: string,
    type: string,
    currencyId: string,
}